import React from 'react';
import { Link } from 'react-router-dom';
import css from './Breadcrumbs.module.css';

/**
 * Visible breadcrumb trail. Mirrors the BreadcrumbList JSON-LD so the on-page
 * link tree and the structured data stay in sync. `crumbs` is an ordered list
 * of { label, path }; the last item is rendered as plain text (current page).
 */
const Breadcrumbs = ({ crumbs }) => {
  if (!crumbs || crumbs.length === 0) {
    return null;
  }

  return (
    <nav className={css.root} aria-label="Brödsmulor">
      <ol className={css.list}>
        {crumbs.map((crumb, index) => {
          const isLast = index === crumbs.length - 1;
          return (
            <li key={crumb.path} className={css.item}>
              {isLast || !crumb.path ? (
                <span className={css.current} aria-current="page">
                  {crumb.label}
                </span>
              ) : (
                <>
                  <Link className={css.link} to={crumb.path}>
                    {crumb.label}
                  </Link>
                  <span className={css.separator} aria-hidden="true">
                    ›
                  </span>
                </>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
